import { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";
import { Navigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

// Used to restrict certain features from un-authenticated users
// Prompts login if necessary

function Wrapper({ children }) {
    const [authenticated, setAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getSession = async () => {
            const { data } = await supabase.auth.getSession();
            setAuthenticated(!!data?.session?.user);
            setLoading(false);
        };
        getSession();
    },[]);

    if (loading) {
        return <div style={{ flex: '1', padding: '40px', textAlign: 'center' }}>
            <CircularProgress/>
        </div>
    } else if (authenticated) {
        return <>{children}</>
    } else {
        return <Navigate to="/sign_in" />;
    }
}
export default Wrapper;